var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75022 0.393756L4.07107 3.0729L1.39192 0.393756C1.13812 0.139952 0.718626 0.139952 0.464823 0.393755C0.21102 0.647559 0.21102 1.06705 0.464823 1.32085L3.14397 4L0.464823 6.67915C0.21102 6.93295 0.21102 7.35244 0.464823 7.60624C0.718626 7.86005 1.13812 7.86005 1.39192 7.60624L4.07107 4.9271L6.75022 7.60624C7.00402 7.86005 7.42351 7.86005 7.67731 7.60624C7.93112 7.35244 7.93112 6.93295 7.67731 6.67915L4.99816 4L7.67731 1.32085C7.93112 1.06705 7.93112 0.647558 7.67731 0.393755C7.42351 0.139952 7.00402 0.139952 6.75022 0.393756Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonClose);
export default __webpack_public_path__ + "static/media/ButtonClose.d4b3846d360a4d22eaaf2a6a3d3711f4.svg";
export { ForwardRef as ReactComponent };